import React from "react"
//import $ from "jquery";
import { useStaticQuery, graphql } from "gatsby"

import './Header.scss';

import SearchMenu from "../NavMenu/NavMenu"
import TopMenu from "./Sections/TopMenu"
import PrimaryHeader from "./Sections/PrimaryHeader"

import {RenderComponent} from "../../modules/render-component";

// Images

const Header = (props) => {
  
  const renderComponent = RenderComponent()

  const data = useStaticQuery(graphql`
  query HeaderQuery{
    glstrapi {

      socialLink {
        top_menu {
          id
          message_text
          links {
            target
            link_type
            label
            custom_link
            menu_item {
              slug
              parent {
                slug
                parent {
                  slug
                }
              }
            }
          }
        }
      }

      siteConfig {
        linkedin_link
        instagram_link
        facebook_link
        pinterest_link
        twitter_link
        youtube_link
        show_sociallinks_burgermenu
        show_topmenu_burger_menu

        Header_Logo {
          url
          alternativeText
          width
          height
        }
        Header_Bg_White_Logo{
          url
          alternativeText
          width
          height
        }
      }
    }
    
  }`)

  var header_data = data.glstrapi;

  //console.log("header_data", header_data)


  return (
    <React.Fragment>

      {header_data?.siteConfig?.show_topmenu_burger_menu && 
      <TopMenu data={header_data?.socialLink?.top_menu} currency={props?.currency} /> }

      <PrimaryHeader GQLPage={props.GQLPage} handlerClick={props.handlerClick} />

      <div className="search-section">
        <SearchMenu showMenu={props.showMenu} toggleSearch = {props.handlerClick} top_menu={header_data?.socialLink?.top_menu} site_config={header_data.siteConfig}/>
      </div>
    </React.Fragment>
  )
}



export default Header